import PageHeader from './PageHeader';

export default PageHeader;
export { PageHeader };
